export const SELECT = 'SELECT_WEIGHT_ADJUSTMENT';
export const DEFAULT = 'DEFAULT_WEIGHT_ADJUSTMENT';
export const FETCH_DATA_PENDING = 'FETCH_DATA_PENDING_WEIGHT_ADJUSTMENT';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS_WEIGHT_ADJUSTMENT';
export const FETCH_DATA_ERROR = 'FETCH_DATA_ERROR_WEIGHT_ADJUSTMENT';

export function fetchDataPending() {
  return {
    type: FETCH_DATA_PENDING
  }
}

export function fetchDataSuccess(data) {
  return {
    type: FETCH_DATA_SUCCESS,
    data: data
  }
}

export function fetchDataError(error) {
  return {
    type: FETCH_DATA_ERROR,
    error: error
  }
}
